import client from '../utils/client';
import { gql } from '@apollo/client';
import { VolumeLicenseInfoFragment } from '../utils/fragments';

type Error =
	| 'INVALID_ENTRIES'
	| 'NETWORK_ERROR'
	| 'UNAUTHORIZED'
	| 'VOLUME_LICENSE_NOT_FOUND'
	| 'EXCEEDS_NUMBER_OF_LICENSES'
	| 'VOLUME_LICENSE_NOT_ACTIVE'
	| 'USER_ALREADY_IN_DIFFERENT_COMPANY'
	| 'USER_ALREADY_IN_DIFFERENT_DEPARTMENT';

const inviteToVolumeLicense = async ({
	id,
	csvOrTsvString,
}: {
	id: string;
	csvOrTsvString: string;
}): Promise<
	| { success: true; error: undefined; errorMessage: undefined }
	| { success: false; error: Error; errorMessage?: string }
> => {
	try {
		const { errors } = await client.mutate({
			mutation: gql`
				mutation InviteToVolumeLicense($id: ID!, $csvOrTsvString: String!) {
					inviteToVolumeLicense(id: $id, csvOrTsvString: $csvOrTsvString) {
						...VolumeLicenseInfoFragment
					}
				}
				${VolumeLicenseInfoFragment}
			`,
			variables: { id, csvOrTsvString },
			errorPolicy: 'all',
			refetchQueries: ['CurrentUser'],
		});
		if (errors) {
			const errorCode = errors[0]?.extensions?.code as Error;
			const errorMessage = errors[0]?.message;
			return {
				success: false,
				error: errorCode,
				errorMessage,
			};
		}
		return {
			success: true,
			error: undefined,
			errorMessage: undefined,
		};
	} catch (e) {
		if (e && e.networkError)
			return { success: false, error: 'NETWORK_ERROR', errorMessage: undefined };
		throw e;
	}
};

export default inviteToVolumeLicense;
